import type React from 'react';

import { useAppState } from '../../../AppStateProvider';
import type { Page } from '../../../domain/page';

import { MultipleDomainsEmail } from './variants/MultipleDomainsEmail';
import { MultipleDomainsMeeting } from './variants/MultipleDomainsMeeting';

export type MultipleDomainsVariant = Page.Email | Page.Meeting;

const config: Record<
  MultipleDomainsVariant,
  {
    ComponentVariant: React.FC<{ selectedDomain?: string; selectedDomainName?: string; domainsAmount?: number }>;
    dropdownButtonText: string;
    isVisible: (domainsAmount?: number) => boolean;
    dropdownWidth: number;
  }
> = {
  ['meeting']: {
    ComponentVariant: MultipleDomainsMeeting,
    dropdownButtonText: 'meeting.external_meeting',
    isVisible: () => true,
    dropdownWidth: 299,
  },
  ['email']: {
    ComponentVariant: MultipleDomainsEmail,
    dropdownButtonText: 'email.correspondence_with',
    isVisible: () => true,
    dropdownWidth: 251,
  },
};

export const useMultipleDomainsVariant = () => {
  const { page } = useAppState();

  if (page in config) {
    return config[page as MultipleDomainsVariant];
  }

  return {
    ComponentVariant: () => null,
    dropdownButtonText: '',
    isVisible: (domainsAmount?: number) => domainsAmount && domainsAmount > 1,
    dropdownWidth: 379,
  };
};
